//src/utils/timeUtils.ts

export const createdAgo = (createdAt: string): string => {
    // Handle non-string inputs
    if (typeof createdAt !== 'string') {
        throw new Error('createdAt must be a string');
    }

    // Handle empty string
    if (createdAt.trim() === '') {
        throw new Error('createdAt cannot be an empty string');
    }

    const createdDate = new Date(createdAt);
    
    // Handle invalid date
    if (isNaN(createdDate.getTime())) {
        throw new Error('Invalid date string provided');
    }

    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - createdDate.getTime()) / 1000);
    
    // Handle future dates (negative difference)
    if (diffInSeconds < 0) {
        return "now";
    }
    
    if (diffInSeconds < 60) {
        return "now";
    }
    
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return `${diffInMinutes}m ago`;
    }
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `${diffInHours}h ago`;
    }
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
        return `${diffInDays}d ago`;
    }
    
    const diffInWeeks = Math.floor(diffInDays / 7);
    return `${diffInWeeks}w ago`;
}; 